/**
 * CollabMark — LuxRally partnership signature glyph.
 * ---------------------------------------------------------------------------
 * Double-hairline `×` mark used as the connector in collaboration lockups
 * (e.g. `LUXRALLY × CREATORS`, `FAIN AND LAURA × LUXRALLY TRAVEL`). Two
 * thin parallel lines per stroke echo the LR cipher's parallel slants, so
 * the mark reads as a sibling of the existing brand identity rather than
 * a one-off ornament.
 *
 * Inherits currentColor so it color-matches whatever text it sits inside.
 * Sized via the `size` prop (px) — pair to the cap-height of the
 * surrounding caps text for optical alignment.
 */

interface CollabMarkProps {
    size?: number;
    className?: string;
    'aria-hidden'?: boolean;
}

export function CollabMark({ size = 12, className, 'aria-hidden': ariaHidden = true }: CollabMarkProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="0.9"
            strokeLinecap="round"
            className={className}
            aria-hidden={ariaHidden}
        >
            {/* top-left → bottom-right pair */}
            <line x1="5.5" y1="6" x2="17.5" y2="18" />
            <line x1="7" y1="4.8" x2="19" y2="16.8" />
            {/* top-right → bottom-left pair */}
            <line x1="18.5" y1="6" x2="6.5" y2="18" />
            <line x1="17" y1="4.8" x2="5" y2="16.8" />
        </svg>
    );
}
